import { render } from "./econtacts.vue?vue&type=template&id=056374ec"
import script from "./econtacts.vue?vue&type=script&lang=js"
export * from "./econtacts.vue?vue&type=script&lang=js"

import "./econtacts.vue?vue&type=style&index=0&id=056374ec&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__